const dashOnlyPattern = /^[\-\u2010-\u2015\u2212]+$/;

export const hasMeaningfulValue = (
    value?: string | null
): value is string => {
    if (value === null || value === undefined) {
        return false;
    }

    const trimmed = String(value).trim();

    if (!trimmed) {
        return false;
    }

    const normalized = trimmed.replace(/[\s\u00a0]+/g, '');

    return !dashOnlyPattern.test(normalized);
};
